import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Button, Checkbox } from '@pwc/pwc-deals-ui';
import { getContentMessage } from '../../utils/groupsUtilities';
import MoveAnalysisModal from '../MoveAnalysisModal/MoveAnalysisModal';
import './AnalysesHoverMenu.scss';
import Group from '../../models/Group';

type Props = {
  groups: Group[];
  selectedAnalysisCount: number;
  handleDeselect: () => void;
  handleDelete: () => void;
  handleMove: (group: Group) => void;
};

const AnalysesHoverMenu: FC<Props> = ({
  groups,
  selectedAnalysisCount,
  handleDeselect,
  handleDelete,
  handleMove,
}) => {
  const { t } = useTranslation();
  const [show, setShow] = useState<boolean>(false);
  const hasGroups = groups && groups.length > 1;
  const analysisSelected = `${getContentMessage(selectedAnalysisCount, t)} ${t(
    'selected'
  )}`;

  const showMoveDialog = () => {
    setShow(true);
  };
  const confirmMove = (group: Group) => {
    setShow(false);
    handleMove(group);
  };

  return (
    <>
      <div className="analysis-hover-menu">
        <div className="analysis-hover-menu__analysis-selected">
          {analysisSelected}
        </div>
        <div className="analysis-hover-menu__deselect">
          <Checkbox
            dataTestId="select-for-drag-checkbox"
            id="analyses-hover-menu-selector"
            label={t('deselectAll')}
            onChange={handleDeselect}
            selected
            indeterminate={false}
          />
        </div>
        <div className="analysis-hover-menu__delete-analyses">
          <Button
            className="ui-button button-menu"
            icon=""
            iconClasses=""
            onClick={handleDelete}
          >
            <Icon name="bin" width="24" className="sr2 outline icon-orange" />
            {t('delete')}
          </Button>
        </div>
        <div className="analysis-hover-menu__move-group">
          <Button
            className="ui-button button-menu"
            icon=""
            iconClasses=""
            onClick={showMoveDialog}
            disabled={!hasGroups}
          >
            <Icon name="move" width="24" className="sr2 outline icon-orange" />
            {t('moveToGroup')}
          </Button>
        </div>
      </div>
      <MoveAnalysisModal
        groups={groups}
        show={show}
        setShow={setShow}
        confirm={confirmMove}
      />
    </>
  );
};

export default AnalysesHoverMenu;
